var _defs, _circle, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetFriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6c6c6c;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 99.65,
    cy: 72.57,
    r: 2.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.74,72.57c-5.56-3-16.41-6.69-22.52-16.74S92,45.75,83,49.19,66.88,62.56,64.77,72.57s-5,13.18-10.07,19-7.56,12.82-4.61,19.16a31.11,31.11,0,0,0,13,14.14s5.68,3.8,28.46,5.91,45.83-10.6,53-27S141.3,75.56,135.74,72.57ZM99.4,107.34a1.14,1.14,0,1,1,1.13-1.13A1.14,1.14,0,0,1,99.4,107.34ZM110.5,102a32.37,32.37,0,0,1,5.74,22.7,38,38,0,0,1-14.31,4c1.41-5.39-1.05-12.35-1.05-12.35,7.94-.36,7.32-7.42,7.32-7.42s-3.18-.27-3.71-1.86a11,11,0,0,0-1.95-4.23c-1.68-2.56-5.21-2.3-5.21-2.3l-.63-4.16c-5.56,1-7.42,2.2-8.92,9.89s-2.2,12.63-6.62,16.34-10.85,2.56-10.85,2.56,5.84-8.12,8.47-16.24,1.68-17.39,1.68-17.39,6.19,2.12,7.52,2.38,1-1.5,2.1-5.56-1.21-6.9-2.81-9.9S86.4,71,86.4,71c-5.47,6.54,1.32,11.75,1.5,14.31s-1.41,5.39-2.48,5.46-9.8-3.26-11.48-4.5-2.48-2.39-2-4.59S78.35,67.4,88.41,64.39s12.45,1.23,18.27,2.66a21.09,21.09,0,0,0,11.47-.88c3.71,7.32-3.26,12.28-8.12,16.51S102.64,90.88,110.5,102Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 40.14,
    cy: 61.48,
    rx: 13.12,
    ry: 17.65,
    transform: "translate(-23.83 25.43) rotate(-27.46)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 140.47,
    cy: 46.54,
    rx: 17.65,
    ry: 13.12,
    transform: "translate(53.75 166.45) rotate(-72.46)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 108.63,
    cy: 20.9,
    rx: 20.91,
    ry: 15.54,
    transform: "translate(55.96 118.18) rotate(-72.46)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 63.05,
    cy: 27.29,
    rx: 15.54,
    ry: 20.91,
    transform: "translate(-5.29 20.27) rotate(-17.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.46,140.37a7,7,0,0,1,5.1,1.28A5.93,5.93,0,0,1,95.88,146a5.85,5.85,0,0,1-1.48,4.72,7.35,7.35,0,0,1-4.9,2.21l-4,.39.86,9.07-4.18.39-2-21.62Zm-.17,9.38a4,4,0,0,0,2.54-1,2.74,2.74,0,0,0,.72-2.36c-.2-2-1.56-2.87-4.12-2.62l-2.85.27.57,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.57,138.08l.31,3.26-9.8.94.55,5.68,9.37-.9.31,3.26-9.37.9.59,6.15,10-1,.32,3.26L100.66,161l-2-21.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.63,136l.31,3.26-7.67.72L129,158.32l-4.18.39-1.74-18.34-7.67.72-.31-3.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.85,168.08l.16,1.64-4.53.43.27,2.81,4.53-.43.16,1.66-4.53.43.45,4.76-2.09.2-1-10.85Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.67,167.52a3.65,3.65,0,0,1,2.58.6,2.79,2.79,0,0,1,1.17,2.11,2.73,2.73,0,0,1-.34,1.66,3.12,3.12,0,0,1-1.3,1.21,2.88,2.88,0,0,1,1,.68,9.11,9.11,0,0,1,1.15,1.53c.78,1.24,1.37,2.1,1.74,2.57l-2.34.22c-.18-.22-.43-.59-.76-1.08a26.76,26.76,0,0,0-1.54-2.2,3.22,3.22,0,0,0-.9-.78,1.79,1.79,0,0,0-.92-.18l-.76.08.43,4.59-2.09.19-1-10.85Zm0,4.68a1.91,1.91,0,0,0,1.25-.53,1.45,1.45,0,0,0,.37-1.17,1.32,1.32,0,0,0-.57-1.07,2.09,2.09,0,0,0-1.36-.23l-1.31.11.29,3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.14,166.72l1,10.85-2.08.19-1-10.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.61,165.82l.15,1.64-4.92.47.28,2.85,4.7-.45L105,172l-4.71.45.3,3.08,5-.47.16,1.64-7.13.68-1-10.85Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.51,165.45l7.16,7-.72-7.58,2-.19,1,10.85-1.8.18L109,168.59l.72,7.69-2,.2-1-10.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.93,164a6.56,6.56,0,0,1,3.09.41,4.93,4.93,0,0,1,2.22,1.76,5.44,5.44,0,0,1,1,2.73,5.53,5.53,0,0,1-.47,2.89,5.15,5.15,0,0,1-1.91,2.11,7.13,7.13,0,0,1-3,1l-4.41.41-1-10.86Zm.65,9.22a3.88,3.88,0,0,0,2.69-1.31,4.12,4.12,0,0,0-.53-5.51,4,4,0,0,0-2.94-.74l-2.17.2.72,7.57Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.77,163.07l.88,9.21,5.27-.51.15,1.64-7.35.7-1-10.85Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.46,162.42l3,3.38,2.31-3.89,2.49-.23-3.59,5.86.51,5.36-2.09.2-.51-5.39-4.64-5.07Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetFriendly);
export default __webpack_public_path__ + "static/media/pet-friendly.c65e4a5bacf4fb8cea5492b028d80a91.svg";
export { ForwardRef as ReactComponent };